<!-- Note: This component is also used in the mega menu file headerDealerHours.vue. Any changes made here will affect that file as well. Please ensure that any modifications are specific to this component to avoid unintended impacts.-->

<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue3 component also
Vue2File: \wwwroot\js\ParagonGroup\components\DealerHours\ClassicFooterDealerHours.vue
Dont forget to make the changes in both the files
Any clarifications contact manideep
-->

<template>
  <div class="dealer-hours-container d-lg-flex h-100">
    <div
      v-for="(salesdata, index) of businessdata"
      :key="index"
      class="department-hours flex-1 mx-2 d-flex justify-content-between flex-column"
    >
      <div>
        <hr class="lightbackground2-primary d-none d-md-block" />
        <div class="details-block">
          <div class="d-flex dealer-icon">
            <h3 v-if="salesdata.department.toLowerCase() == 'quick lane'">
              {{ salesdata.department }} Hours
            </h3>
            <h3 v-else>{{ salesdata.department.replace("Department", "Hours") }}</h3>
          </div>
          <div>
            <div
              class="d-flex justify-content-between pr-md-3"
              :class="currentDayIs === 'sunday' ? 'current-day font-weight-bold ft-16' : ''"
            >
              <div>Sunday:</div>
              <div v-if="salesdata.sundayLabel !== null && salesdata.sundayLabel !== ''">
                {{ salesdata.sundayLabel }}
              </div>
              <div v-else>
                {{ salesdata.sunday }}
              </div>
            </div>
            <div
              class="d-flex justify-content-between pr-md-3"
              :class="currentDayIs === 'monday' ? 'current-day font-weight-bold ft-16' : ''"
            >
              <div>Monday:</div>
              <div v-if="salesdata.mondayLabel !== null && salesdata.mondayLabel !== ''">
                {{ salesdata.mondayLabel }}
              </div>
              <div v-else>
                {{ salesdata.monday }}
              </div>
            </div>
            <div
              class="d-flex justify-content-between pr-md-3"
              :class="currentDayIs === 'tuesday' ? 'current-day font-weight-bold ft-16' : ''"
            >
              <div>Tuesday:</div>
              <div v-if="salesdata.tuesdayLabel !== null && salesdata.tuesdayLabel !== ''">
                {{ salesdata.tuesdayLabel }}
              </div>
              <div v-else>
                {{ salesdata.tuesday }}
              </div>
            </div>
            <div
              class="d-flex justify-content-between pr-md-3"
              :class="currentDayIs === 'wednesday' ? 'current-day font-weight-bold ft-16' : ''"
            >
              <div>Wednesday:</div>
              <div v-if="salesdata.wednesdayLabel !== null && salesdata.wednesdayLabel !== ''">
                {{ salesdata.wednesdayLabel }}
              </div>
              <div v-else>
                {{ salesdata.wednesday }}
              </div>
            </div>
            <div
              class="d-flex justify-content-between pr-md-3"
              :class="currentDayIs === 'thursday' ? 'current-day font-weight-bold ft-16' : ''"
            >
              <div>Thursday:</div>
              <div v-if="salesdata.thursdayLabel !== null && salesdata.thursdayLabel !== ''">
                {{ salesdata.thursdayLabel }}
              </div>
              <div v-else>
                {{ salesdata.thursday }}
              </div>
            </div>
            <div
              class="d-flex justify-content-between pr-md-3"
              :class="currentDayIs === 'friday' ? 'current-day font-weight-bold ft-16' : ''"
            >
              <div>Friday:</div>
              <div v-if="salesdata.fridayLabel !== null && salesdata.fridayLabel !== ''">
                {{ salesdata.fridayLabel }}
              </div>
              <div v-else>
                {{ salesdata.friday }}
              </div>
            </div>
            <div
              class="d-flex justify-content-between pr-md-3"
              :class="currentDayIs === 'saturday' ? 'current-day font-weight-bold ft-16' : ''"
            >
              <div>Saturday:</div>
              <div v-if="salesdata.saturdayLabel !== null && salesdata.saturdayLabel !== ''">
                {{ salesdata.saturdayLabel }}
              </div>
              <div v-else>
                {{ salesdata.saturday }}
              </div>
            </div>
          </div>
          <p class="ft-12 mt-3" v-if="salesdata.description">
            {{ salesdata.description }}
          </p>
        </div>
      </div>
      <div><hr class="lightbackground2-primary" /></div>
    </div>

    <div
      class="flex-1 mx-2 d-flex justify-content-between flex-column holiday-hours"
      v-if="holidayHours && holidayHours.length"
    >
      <div>
        <hr class="lightbackground2-primary d-none d-md-block" />
        <div class="details-block">
          <div class="d-flex dealer-icon">
            <h3>Holiday Hours</h3>
          </div>
          <div v-for="(holiday, index) of holidayHours" :key="index">
            <div class="d-flex justify-content-between pr-md-3">
              <div>{{ holiday.holidayName }}:</div>

              <div v-if="holiday.isFullDay">
                {{ holiday.holidayMonth }}
                {{ holiday.holidayDay }}{{ getDaySufixLogic(holiday.holidayDay) }}
              </div>
              <div v-else>
                {{ holiday.holidayMonth }}
                {{ holiday.holidayDay }}{{ getDaySufixLogic(holiday.holidayDay) }},
                {{ holiday.fromTime }} -
                {{ holiday.toTime }}
              </div>
            </div>
            <template v-if="holiday.closureDepartments">
              <div class="d-flex justify-content-end pr-md-3">
                <div class="text-muted">
                  {{ getclosureDepartments(holiday.closureDepartments) }}: Closed
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div><hr class="lightbackground2-primary" /></div>
    </div>
  </div>
</template>
<script>
import DealerHours from './DealerHours';
export default {
mixins: [DealerHours],
}
</script>
<style>
.dealer-hours {
  font-size: 14px;
  color: #000;
}
.details-block .d-flex {
  padding: 5px 0;
}
.details-block .d-flex a {
  color: #000;
}
@media (min-width: 768px) {
  .border-md-left {
    border-left: 1px solid #dee2e6;
  }
}
</style>
